'use strict';

exports.__esModule = true;
exports.EMPLOYEE_ID_CHANGE = exports.ADDRESS_POSTCODE_CHANGE = exports.ADDRESS_CITY_CHANGE = exports.ADDRESS_LINE_CHANGE = exports.TOGGLE_POLICY_TERMS_AGREEMENT = exports.POLICY_NUMBER_CHANGE = exports.CLAIM_NUMBER_CHANGE = exports.VALIDATION_ERROR = exports.DOB_YEAR_CHANGE = exports.DOB_MONTH_CHANGE = exports.DOB_DAY_CHANGE = exports.SUBMIT_REQUEST = exports.REASON_CHANGE = exports.PHONE_CHANGE = exports.EMAIL_CHANGE = exports.PASSWORD_CHANGE = exports.TITLE_CHANGE = exports.SEX_CHANGE = exports.LAST_NAME_CHANGE = exports.FIRST_NAME_CHANGE = exports.PRACTICE_CHANGE = exports.CREATE_SUBSCRIPTION = exports.CREATE_SUBSCRIPTION_TOGGLE = exports.CLOSE_REQUEST_APPOINTMENT_MODAL = exports.OPEN_REQUEST_APPOINTMENT_MODAL = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _doctifyUtils = require('doctify-utils');

var _pageActions = require('./page-actions');

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPEN_REQUEST_APPOINTMENT_MODAL = exports.OPEN_REQUEST_APPOINTMENT_MODAL = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:OPEN_REQUEST_APPOINTMENT_MODAL'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var CLOSE_REQUEST_APPOINTMENT_MODAL = exports.CLOSE_REQUEST_APPOINTMENT_MODAL = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:CLOSE_REQUEST_APPOINTMENT_MODAL';
var CREATE_SUBSCRIPTION_TOGGLE = exports.CREATE_SUBSCRIPTION_TOGGLE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:CREATE_SUBSCRIPTION_TOGGLE';
var CREATE_SUBSCRIPTION = exports.CREATE_SUBSCRIPTION = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:CREATE_SUBSCRIPTION';
var PRACTICE_CHANGE = exports.PRACTICE_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:PRACTICE_CHANGE';
var FIRST_NAME_CHANGE = exports.FIRST_NAME_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:FIRST_NAME_CHANGE';
var LAST_NAME_CHANGE = exports.LAST_NAME_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:LAST_NAME_CHANGE';
var SEX_CHANGE = exports.SEX_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:SEX_CHANGE';
var TITLE_CHANGE = exports.TITLE_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:TITLE_CHANGE';
var PASSWORD_CHANGE = exports.PASSWORD_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:PASSWORD_CHANGE';
var EMAIL_CHANGE = exports.EMAIL_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:EMAIL_CHANGE';
var PHONE_CHANGE = exports.PHONE_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:PHONE_CHANGE';
var REASON_CHANGE = exports.REASON_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:REASON_CHANGE';
var SUBMIT_REQUEST = exports.SUBMIT_REQUEST = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:SUBMIT_REQUEST';
var DOB_DAY_CHANGE = exports.DOB_DAY_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:DOB_DAY_CHANGE';
var DOB_MONTH_CHANGE = exports.DOB_MONTH_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:DOB_MONTH_CHANGE';
var DOB_YEAR_CHANGE = exports.DOB_YEAR_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:DOB_YEAR_CHANGE';
var VALIDATION_ERROR = exports.VALIDATION_ERROR = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:VALIDATION_ERROR';
var CLAIM_NUMBER_CHANGE = exports.CLAIM_NUMBER_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:CLAIM_NUMBER_CHANGE';
var POLICY_NUMBER_CHANGE = exports.POLICY_NUMBER_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:POLICY_NUMBER_CHANGE';
var TOGGLE_POLICY_TERMS_AGREEMENT = exports.TOGGLE_POLICY_TERMS_AGREEMENT = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:TOGGLE_POLICY_TERMS_AGREEMENT';
var ADDRESS_LINE_CHANGE = exports.ADDRESS_LINE_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:ADDRESS_LINE_CHANGE';
var ADDRESS_CITY_CHANGE = exports.ADDRESS_CITY_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:ADDRESS_CITY_CHANGE';
var ADDRESS_POSTCODE_CHANGE = exports.ADDRESS_POSTCODE_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:ADDRESS_POSTCODE_CHANGE';
var EMPLOYEE_ID_CHANGE = exports.EMPLOYEE_ID_CHANGE = 'REQUEST_APPOINTMENT_MODAL_ACTIONS:EMPLOYEE_ID_CHANGE';

var RequestAppointmentModalActions = {
  openRequestAppointmentModal: function openRequestAppointmentModal(accountProfileData) {
    return {
      type: OPEN_REQUEST_APPOINTMENT_MODAL,
      accountProfileData: accountProfileData
    };
  },
  openBmiRequestAppointmentModal: function openBmiRequestAppointmentModal(accountProfileData, availability) {
    return {
      type: OPEN_REQUEST_APPOINTMENT_MODAL,
      accountProfileData: accountProfileData,
      availability: availability
    };
  },
  closeModal: function closeModal() {
    return {
      type: CLOSE_REQUEST_APPOINTMENT_MODAL
    };
  },
  onCreateSubscriptionToggle: function onCreateSubscriptionToggle() {
    return {
      type: CREATE_SUBSCRIPTION_TOGGLE
    };
  },
  onPracticeChange: function onPracticeChange(practice) {
    return {
      type: PRACTICE_CHANGE,
      practice: practice
    };
  },
  onFirstNameChange: function onFirstNameChange(name) {
    return {
      type: FIRST_NAME_CHANGE,
      name: name
    };
  },
  onLastNameChange: function onLastNameChange(name) {
    return {
      type: LAST_NAME_CHANGE,
      name: name
    };
  },
  onGenderChange: function onGenderChange(gender) {
    return {
      type: SEX_CHANGE,
      gender: gender
    };
  },
  onTitleChange: function onTitleChange(title) {
    return {
      type: TITLE_CHANGE,
      title: title
    };
  },
  onPasswordChange: function onPasswordChange(password) {
    return {
      type: PASSWORD_CHANGE,
      password: password
    };
  },
  onEmailChange: function onEmailChange(email) {
    return {
      type: EMAIL_CHANGE,
      email: email
    };
  },
  onPhoneChange: function onPhoneChange(phone) {
    return {
      type: PHONE_CHANGE,
      phone: phone
    };
  },
  onVisitReasonChange: function onVisitReasonChange(reason) {
    return {
      type: REASON_CHANGE,
      reason: reason
    };
  },
  onBirthdateDayChange: function onBirthdateDayChange(day) {
    return {
      type: DOB_DAY_CHANGE,
      day: day
    };
  },
  onBirthdateMonthChange: function onBirthdateMonthChange(month) {
    return {
      type: DOB_MONTH_CHANGE,
      month: month
    };
  },
  onBirthdateYearChange: function onBirthdateYearChange(year) {
    return {
      type: DOB_YEAR_CHANGE,
      year: year
    };
  },
  submitAppointmentRequest: function submitAppointmentRequest(requestData, auth, callback) {
    return function (dispatch) {
      var actionConfig = {
        actionType: SUBMIT_REQUEST,
        url: 'specialists/' + requestData.id + '/contact_request',
        method: 'POST',
        callback: callback || null,
        data: requestData,
        additionalActionsOnSuccess: ['bmi', 'ramsay', 'spire', 'nuffield'].includes(requestData.request_type) ? [{
          type: _pageActions.REMOVE_PATIENT_AVAILABILITY,
          actionData: { availability_id: requestData.availability_id }
        }] : null,
        additionalActionsOnFail: ['bmi', 'ramsay', 'spire', 'nuffield'].includes(requestData.request_type) ? [{
          type: _pageActions.REMOVE_PATIENT_AVAILABILITY,
          actionData: { availability_id: requestData.availability_id }
        }] : null,
        auth: auth
      };

      if (!_constants.GOOGLE_RECAPTCHA_APP_KEY) {
        return dispatch((0, _doctifyUtils.createAction)((0, _assign2.default)({}, actionConfig, { headers: {} })));
      }

      return window.grecaptcha.execute(_constants.GOOGLE_RECAPTCHA_APP_KEY, { action: 'submit' }).then(function (token) {
        var headers = {
          'google-recaptcha-token': token,
          'google-recaptcha-site-id': _constants.GOOGLE_RECAPTCHA_APP_KEY
        };

        return dispatch((0, _doctifyUtils.createAction)((0, _assign2.default)({}, actionConfig, { headers: headers })));
      }).catch(function (error) {
        console.error('Error obtaining reCAPTCHA token:', error);
      });
    };
  },
  submitAppointmentRequestSend: function submitAppointmentRequestSend() {
    return {
      type: SUBMIT_REQUEST
    };
  },
  createSubscription: function createSubscription(requestData) {
    return (0, _doctifyUtils.createAction)({
      actionType: CREATE_SUBSCRIPTION,
      url: '/mailing_list/subscription',
      method: 'POST',
      data: requestData
    });
  },
  validationError: function validationError() {
    return {
      type: VALIDATION_ERROR
    };
  },
  onClaimNumberChange: function onClaimNumberChange(claimNumber) {
    return {
      type: CLAIM_NUMBER_CHANGE,
      claimNumber: claimNumber
    };
  },
  onPolicyNumberChange: function onPolicyNumberChange(policyNumber) {
    return {
      type: POLICY_NUMBER_CHANGE,
      policyNumber: policyNumber
    };
  },
  onTogglePolicyTermsAgreement: function onTogglePolicyTermsAgreement(agreeWithTerms) {
    return {
      type: TOGGLE_POLICY_TERMS_AGREEMENT,
      agreeWithTerms: agreeWithTerms
    };
  },
  onAddressLineChange: function onAddressLineChange(addressLine) {
    return {
      type: ADDRESS_LINE_CHANGE,
      addressLine: addressLine
    };
  },
  onAddressCityChange: function onAddressCityChange(addressCity) {
    return {
      type: ADDRESS_CITY_CHANGE,
      addressCity: addressCity
    };
  },
  onAddressPostcodeChange: function onAddressPostcodeChange(addressPostcode) {
    return {
      type: ADDRESS_POSTCODE_CHANGE,
      addressPostcode: addressPostcode
    };
  },
  onEmployeeIdChange: function onEmployeeIdChange(employeeId) {
    return {
      type: EMPLOYEE_ID_CHANGE,
      employeeId: employeeId
    };
  }
};

exports.default = RequestAppointmentModalActions;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/actions/request-appointment-modal.js